/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZabbixConfigurationBase {
    getFixupPrototypeFunction() { return ZabbixConfigurationBase.fixupPrototype; }

    static newInstance(model: Partial<ZabbixConfigurationBase>): ZabbixConfigurationBase {
        let obj = Object.assign(new ZabbixConfigurationBase(), model);
        ZabbixConfigurationBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZabbixConfigurationBase>): ZabbixConfigurationBase {
        if (!model) return null;
        return ZabbixConfigurationBase.newInstance(<ZabbixConfigurationBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZabbixConfigurationBase) {
        if (!obj) return;

        models.ZabbixConfigurationBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZabbixConfigurationBase): boolean {
        Object.setPrototypeOf(obj, ZabbixConfigurationBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.template) {
            models.ZabbixTemplate.fixupPrototype(this.template);
        }
    }

    /**
     * Cloud Provider to select
     */
    cloud_service: models.CloudServiceName;

    template: models.ZabbixTemplate;

    /**
     * Webhook URL for Zabbix Configuration
     */
    webhook_url: string;

}
